import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-super-admin-login',
  templateUrl: './super-admin-login.component.html',
  styleUrls: ['./super-admin-login.component.scss']
})
export class SuperAdminLoginComponent implements OnInit {
  registrationForm: FormGroup;
  isMobValid: any;
  resendMobotp = false;
  send1stMobotp = true;
  isDivDisabled2: boolean = false;
  timerInterval2: NodeJS.Timeout;
  remainingTime2: number = 60;
  isMobileDisabled: boolean = false;
  otpverify2 = false;
  regibtm = true;
  messageee2 = ''
  msgshw3 = false
  msgshw4 =false;

  constructor(private fb: FormBuilder, public umsService:UmsService, 
    private spinner :NgxSpinnerService, private router: Router,
    private modalPopupService: ModalpopService,
    private dialogRef: MatDialogRef<SuperAdminLoginComponent>,) { }

  ngOnInit(): void {
    this.registrationForm = this.fb.group({
      StuMobNumber: new FormControl('',[Validators.required,Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      mobileOTP: new FormControl(''),
    })
  }

  resendMobWithTimeout(){
    this.isDivDisabled2 = true;
    this.resendMobotp = true;
    this.send1stMobotp = false;
    // this.msgshw3 = false;
    //   this.msgshw4 = false;
    this.registrationForm.controls['mobileOTP'].setValue('');
    this.registrationForm.controls['mobileOTP'].clearValidators();
    this.timerInterval2 = setInterval(() => {
      this.remainingTime2--;
       this.isMobileDisabled = true;
      if (this.remainingTime2 === 0) {
        clearInterval(this.timerInterval2);
        this.isDivDisabled2 = false;
        this.remainingTime2 = 60; // Reset the timer for the next attempt
        this.resendMobotp = true;
        this.send1stMobotp = false;
        this.isMobileDisabled = false;
      }
    }, 1000);

    this.SendMobile();
  }

  SendMobile(){
    // this.emaildisabled = true;
      this.otpverify2 = false;
      this.spinner.show();
      let payload = {};
      payload['MobNo'] = this.registrationForm.value.StuMobNumber;
      this.umsService.SendMobile(payload).subscribe(res => {
        if(res.status){
          // this.sendotpmail = true;
          // this.bfrsendotpmail = false
          this.spinner.hide();
          this.otpverify2 = true;
        this.umsService.openSnackbar("Otp Sent to - "+this.registrationForm.value.StuMobNumber);
        }
        // else{
        //   this.sendotpmail = false;
        //   this.bfrsendotpmail = true
        // }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.umsService.openSnackbar(ERROR.error.message);
     });
  }

  verifySuperAdmin() {
    let payload = {};
    payload['MobNumber'] = this.registrationForm.value.StuMobNumber;
    this.umsService.VerifySuper(payload).subscribe((res) => {
      if(res.status) {
        this.sendMobWithTimeout();
      }
      else {
        let  data = {}
        data['message'] = res.message;
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    })
  }

  sendMobWithTimeout(){
    const mobileControl = this.registrationForm.controls['StuMobNumber'];
    if (mobileControl.invalid || this.isDivDisabled2) {
      return; // Exit the function if the mobile is invalid or the button is disabled
    }
    this.isDivDisabled2 = true;
    this.resendMobotp = false;
    this.send1stMobotp = true;
    this.timerInterval2 = setInterval(() => {
      this.remainingTime2--;
      this.isMobileDisabled = true;
      if (this.remainingTime2 === 0) {
        clearInterval(this.timerInterval2);
        this.isDivDisabled2 = false;
        this.remainingTime2 = 60; // Reset the timer for the next attempt
        this.resendMobotp = true;
        this.send1stMobotp = false;
        this.isMobileDisabled = false;
      }
    }, 1000);
    this.SendMobile();
  }

   verifyMobOtp(){
    let payload = {};
    payload['MobNo'] = this.registrationForm.value.StuMobNumber;
    payload['OTP'] = this.registrationForm.value.mobileOTP
    this.umsService.VerifyMobile(payload).subscribe(res => {
      console.log('res of verify',res.data);
      if(res.status){
        this.msgshw3 = true;
        this.msgshw4 = false;
        this.otpverify2 = false;
        this.regibtm = false;
        // this.btnShow = true;
        // this.btnShow2 = false;
        let logPayload = {};
        logPayload['LoginId'] = sessionStorage.getItem('userId');
        logPayload['MobileNumber'] = this.registrationForm.value.StuMobNumber;
        logPayload['OTP'] = this.registrationForm.value.mobileOTP;
        logPayload['LoginTimestamp'] = new Date().toISOString();
        logPayload['OTPGeneratedOn'] = new Date().toISOString(); 
        logPayload['VerificationStatus'] = 'SUCCESS';
        this.umsService.logSuperOTP(logPayload).subscribe((resp) => {
          this.messageee2 = "OTP Verified";
          this.dialogRef.close({
            updateFlag: true
          });
        })
      }
      else{
        this.otpverify2 = true;
        this.msgshw3 = false;
        this.msgshw4 = true;
        this.regibtm = true;
        // this.btnShow = false;
        // this.btnShow2 = true;
        this.messageee2 = "Invalid OTP"
      }
    },(ERROR:HttpErrorResponse) => {
      this.otpverify2 = true;
      this.msgshw3 = false;
      this.msgshw4 = true;
      this.regibtm = true;
      // this.btnShow = false;
      // this.btnShow2 = true;
      this.messageee2 = "Invalid OTP"
    })
  }

  isValidMob(num: string): boolean {
    const mobileRegex: RegExp = /^(0|91)?[6-9][0-9]{9}/
    return mobileRegex.test(num);
  }

   mobilevalid(value: string){
    this.isMobValid = this.isValidMob(value);
  }

  Update() {
    
  }

}
